// Product Showcase Section JS
window.initProductShowcaseSection = function(sectionId) {
  const productsGrid = document.getElementById(`parts-products-grid-${sectionId}`);
  const navItems = document.querySelectorAll(`.parts-nav-item-${sectionId}`);

  if (!productsGrid || !navItems.length) return;

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttribute(value) {
    return escapeHtml(value);
  }

  function generateBadge(tags) {
    if (!tags || !Array.isArray(tags)) return '';

    const tagsLower = tags.map(tag => String(tag).toLowerCase());
    if (tagsLower.includes('new')) {
      return `<span class="parts-product-badge-${sectionId} parts-badge-new-${sectionId}">New</span>`;
    }
    if (tagsLower.includes('hot')) {
      return `<span class="parts-product-badge-${sectionId} parts-badge-hot-${sectionId}">Hot</span>`;
    }
    return '';
  }

  function createProductCard(product) {
    const productUrl = escapeAttribute(product.url || '#');
    const productTitle = escapeHtml(product.title);
    const imageAlt = escapeAttribute(product.featured_image_alt || product.title);
    const imageHtml = product.featured_image
      ? `<img src="${escapeAttribute(product.featured_image)}" alt="${imageAlt}" class="parts-product-image-${sectionId}" loading="lazy">`
      : `<div class="parts-product-image-placeholder-${sectionId}"><span>No image</span></div>`;

    const badge = generateBadge(product.tags);
    const soldOutBadge = !product.available
      ? `<div class="parts-sold-out-badge-${sectionId}">Sold out</div>`
      : '';

    return `
      <div class="parts-product-wrapper-${sectionId}">
        <div class="parts-product-card-${sectionId}">
          <a href="${productUrl}" class="parts-product-image-wrapper-${sectionId}">
            ${imageHtml}
            ${soldOutBadge}
          </a>
          <div class="parts-product-info-${sectionId}">
            <div class="parts-product-title-row-${sectionId}">
              <h3 class="parts-product-title-${sectionId}">${productTitle}</h3>
              ${badge}
            </div>
            <div class="parts-product-actions-${sectionId}">
              <a href="${productUrl}" class="parts-product-link-${sectionId}">Explore &gt;</a>
              <a href="${productUrl}" class="parts-product-link-${sectionId}">Shop &gt;</a>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function showNoCollectionMessage() {
    productsGrid.classList.remove('loading');
    productsGrid.innerHTML = `<div class="parts-no-collection-message-${sectionId}">Please select a collection in the theme settings.</div>`;
  }

  function showNoProductsMessage(collectionTitle) {
    productsGrid.classList.remove('loading');
    productsGrid.innerHTML = `<div class="parts-no-collection-message-${sectionId}">${escapeHtml(collectionTitle)} has no products.</div>`;
  }

  function loadCollection(collectionHandle, blockId) {
    productsGrid.classList.add('loading');

    const collectionDataScript = document.getElementById(`parts-collection-data-${blockId}-${sectionId}`);
    if (!collectionDataScript) {
      showNoCollectionMessage();
      return;
    }

    try {
      const collectionData = JSON.parse(collectionDataScript.textContent);
      window.setTimeout(() => {
        productsGrid.classList.remove('loading');
        productsGrid.innerHTML = '';

        const allEquipmentLink = document.getElementById(`parts-all-equipment-link-${sectionId}`);
        if (allEquipmentLink && collectionData.collection_url) {
          allEquipmentLink.href = collectionData.collection_url;
        }

        if (collectionData.products && collectionData.products.length > 0) {
          productsGrid.innerHTML = collectionData.products.map(createProductCard).join('');

          if (typeof gtag !== 'undefined') {
            gtag('event', 'collection_switch', {
              event_category: 'navigation',
              event_label: collectionData.collection_title,
              section_id: sectionId
            });
          }
        } else {
          showNoProductsMessage(collectionData.collection_title);
        }
      }, 300);
    } catch (error) {
      console.error('Error parsing collection data:', error);
      showNoCollectionMessage();
    }
  }

  navItems.forEach(item => {
    if (item.dataset.partsNavBound === 'true') return;
    item.dataset.partsNavBound = 'true';

    item.addEventListener('mouseenter', function() {
      const collectionHandle = this.dataset.collection;
      const blockId = this.dataset.blockId;

      if (!collectionHandle) {
        showNoCollectionMessage();
        return;
      }

      navItems.forEach(nav => nav.classList.remove('active'));
      this.classList.add('active');
      loadCollection(collectionHandle, blockId);
    });
  });

  const firstNavItem = navItems[0];
  if (firstNavItem && productsGrid.dataset.partsInitialized !== 'true') {
    productsGrid.dataset.partsInitialized = 'true';
    const firstCollectionHandle = firstNavItem.dataset.collection;
    const firstBlockId = firstNavItem.dataset.blockId;

    if (firstCollectionHandle) {
      loadCollection(firstCollectionHandle, firstBlockId);
    } else {
      showNoCollectionMessage();
    }
  }

  window.__partsProductShowcaseClickHandlers = window.__partsProductShowcaseClickHandlers || {};
  if (!window.__partsProductShowcaseClickHandlers[sectionId]) {
    document.addEventListener('click', function(e) {
      const productWrapper = e.target.closest(`.parts-product-wrapper-${sectionId}`);
      if (!productWrapper) return;

      const productTitle = productWrapper.querySelector(`.parts-product-title-${sectionId}`)?.textContent || '';
      if (typeof gtag !== 'undefined') {
        gtag('event', 'product_click', {
          event_category: 'engagement',
          event_label: productTitle,
          section_id: sectionId
        });
      }
    });
    window.__partsProductShowcaseClickHandlers[sectionId] = true;
  }
};
